import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  border: ${({ theme }) => theme.border.width.thinner} ${({ theme }) => theme.border.style.solid};
  border-color: ${({ theme }) => theme.color.border.neutral.default};
  border-radius: ${({ theme }) => theme.border.radius.medium};
  flex-direction: column;
`

export const Title = styled.div<{ isLoading?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ isLoading, theme }) => (isLoading ? theme.padding.km3 : theme.padding.km0)};
  padding: ${({ theme }) => theme.padding.km6} ${({ theme }) => theme.padding.km6} ${({ theme }) => theme.padding.km0}
    ${({ theme }) => theme.padding.km6};
`

export const ContentWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`

export const Content = styled(Title)`
  padding: ${({ theme }) => theme.spacing.km0} ${({ theme }) => theme.spacing.km12};

  &:first-child {
    margin-top: ${({ theme }) => theme.spacing.km6};
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    padding: ${({ theme }) => theme.padding.km0} ${({ theme }) => theme.padding.km6};
  }
`

export const InvoiceWrapper = styled.div<{ isExpired: boolean }>`
  display: flex;
  background: ${({ isExpired }) => (isExpired ? '#FFF4F4' : '#f4f4f5')};
  padding: ${({ theme }) => theme.spacing.km6} ${({ theme }) => theme.spacing.km12};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    padding: ${({ theme }) => theme.padding.km6};
  }
`

export const ConsumptionData = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.padding.km2};
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing.km2};
`

export const InvoiceData = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ConsumptionLoader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.km5};

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.km5};
  }
`
